import $ from 'jquery';
import Cookies from 'js-cookie';

export class ThirdPartyNotification {
  constructor(config) {
    this.config = {
      ids: [],
      allCookieName: 'man-cookies-accepted',
      thirdPartyCookieName: 'man-third-party-accepted',
      thirdPartyCookieExpiry: 365,
      acceptEventName: 'thirdparty.accepted',
      acceptButton: '[data-action="accept-third-party"]',
      acceptedClass: 'third-party-accepted',
      ...config,
    };

    const modalsReady = document.querySelector('body').classList.contains('modals-ready');

    if (modalsReady) {
      this.init();
    } else {
      window.addEventListener('modal-third-party-notification-ready', () => {
        this.init();
      });
    }
  }

  init() {
    const { allCookieName, thirdPartyCookieName } = this.config;

    if (!Cookies) return;

    if (!Cookies.get(allCookieName) && !this.cookieContentMatchIds(Cookies.get(thirdPartyCookieName))) {
      this.events();
    } else {
      this.triggerAcceptedEvent();
    }
  }

  events() {
    const { acceptButton } = this.config;

    const acceptButtons = document.querySelectorAll(acceptButton);

    if (acceptButtons.length > 0) {
      acceptButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          this.onAcceptButtonClick(e);
        });
      });
    } else {
      console.warn('Third Party Notification - Accept button not found, check modal');
    }
  }

  triggerAcceptedEvent(target) {
    const { acceptEventName, acceptedClass } = this.config;
    const eventTarget = target || window;
    const event = new CustomEvent(acceptEventName, { bubbles: true, cancelable: false });

    $('html').addClass(acceptedClass);
    eventTarget.dispatchEvent(event);
  }

  onCookiesAccepted() {
    this.setCookie();
    this.triggerAcceptedEvent();
  }

  onPermissionRevoked() {
    this.deleteCookie();
  }

  onAcceptButtonClick(e) {
    this.setCookie();
    this.triggerAcceptedEvent(e.target);
  }

  setCookie() {
    const { thirdPartyCookieName, thirdPartyCookieExpiry } = this.config;
    const content = this.config.ids.join(',');

    Cookies.set(thirdPartyCookieName, content, { expires: thirdPartyCookieExpiry });
  }

  deleteCookie() {
    const { thirdPartyCookieName } = this.config;

    Cookies.remove(thirdPartyCookieName);
  }

  cookieContentMatchIds(cookie) {
    if (!cookie) return false;

    const { ids } = this.config;
    const contentArray = cookie.split(',');

    return contentArray.length === ids.length && contentArray.sort().every((value, i) => value === ids.sort()[i]);
  }
}
